import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import ApartmentPage from './components/ApartmentPage';
import ploiesti from './properties/ploiesti';
import colentina from './properties/colentina';

// Redirect that keeps the query string (e.g. ?test=true used by analytics)
function RedirectTo({ to }) {
  const { search, hash } = useLocation();
  return <Navigate to={`${to}${search}${hash}`} replace />;
}

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        {/* The homepage shows the Bucharest duplex */}
        <Route path="/" element={<RedirectTo to={colentina.path} />} />
        <Route path={colentina.path} element={<ApartmentPage property={colentina} />} />
        <Route path={ploiesti.path} element={<ApartmentPage property={ploiesti} />} />
        {/* Anything else falls back to the homepage */}
        <Route path="*" element={<RedirectTo to={colentina.path} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
